export interface TestimonialsItemModel {
    text: string;
    author: string;
    company: string;
}

export const testimmonialsItems: TestimonialsItemModel[] = [
    {
        text: '1AWE is by far the best choice for our Library! The interactive games, e-books, and new integrated graphics make this a huge benefit for families to help their young learners thrive in a fun and engaging way.',
        author: 'Kathy A.',
        company: 'Tempe Public Library, AZ',
    },
    {
        text: '2AWE is by far the best choice for our Library! The interactive games, e-books, and new integrated graphics make this a huge benefit for families to help their young learners thrive in a fun and engaging way.',
        author: 'Kathy B.',
        company: 'Tempe Public Library, AZ',
    },
    {
        text: '3AWE is by far the best choice for our Library! The interactive games, e-books, and new integrated graphics make this a huge benefit for families to help their young learners thrive in a fun and engaging way.',
        author: 'Kathy C.',
        company: 'Tempe Public Library, AZ',
    },
    {
        text: '4AWE is by far the best choice for our Library! The interactive games, e-books, and new integrated graphics make this a huge benefit for families to help their young learners thrive in a fun and engaging way.',
        author: 'Kathy D.',
        company: 'Tempe Public Library, AZ',
    },
    {
        text: '5AWE is by far the best choice for our Library! The interactive games, e-books, and new integrated graphics make this a huge benefit for families to help their young learners thrive in a fun and engaging way.',
        author: 'Kathy E.',
        company: 'Tempe Public Library, AZ',
    },
    {
        text: '6AWE is by far the best choice for our Library! The interactive games, e-books, and new integrated graphics make this a huge benefit for families to help their young learners thrive in a fun and engaging way.',
        author: 'Kathy F.',
        company: 'Tempe Public Library, AZ',
    },
];
